import styled from '@emotion/styled';

export const IconWrapper = styled.div`
  cursor: pointer;
  text-align: center;
  margin: auto;
  height: 100px;
  z-index: 1;
`;
